var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppPremierePro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#00005B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2358 14.4336C27.2666 14.4336 31.2256 17.7268 31.2256 23.2402C31.2256 29.6787 25.8604 32.2688 20.8281 32.2688H17.4238V39.2253H10.541V14.4336H20.2358ZM17.4238 20.3171V26.3855H20.458C22.5669 26.3855 24.0469 25.5344 24.0469 23.3882C24.0469 21.427 22.7891 20.3171 20.6055 20.3171L17.4238 20.3171Z",
    fill: "#9999FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1289 19.5769C42.646 19.5769 43.8672 19.762 44.4224 19.947V24.9793C43.9785 24.8684 43.127 24.7944 42.4238 24.7944C41.0547 24.7944 40.2778 24.9053 39.5752 25.1643V39.2254H33.0996V21.2051C35.4307 20.169 37.7617 19.5769 41.1289 19.5769Z",
    fill: "#9999FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppPremierePro);
export default __webpack_public_path__ + "static/media/B_app_PremierePro.b0e88a605ffdf1925350d2d97a3045b2.svg";
export { ForwardRef as ReactComponent };